import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import { Input } from 'components/common/Input';
import {
  city_validation,
  country_validation,
  PLZ_validation,
  state_validation,
  street_validation,
} from 'helpers/Validation/InputValidation';
import { AuthPost } from 'helpers/api/AuthCRUD';
import { API } from 'helpers/api/endpoints';
import { useState } from 'react';
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { Form, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const isNull = (arg: string | undefined | null) => {
  return arg ? arg : '';
};
type Props = {
  refetch: () => void;
  customerGuid: string;
};
export default function AddAddressModal({ refetch, customerGuid }: Props) {
  const { t } = useTranslation('translation');
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const methods = useForm();

  const { token, user } = useSelector((state: RootState) => state);
  const [loading, setLoading] = useState(false);

  const CreateAddress = methods.handleSubmit(async (data) => {
    setLoading(true);

    if (token) {
      const response = await AuthPost(
        API.addresses.add(customerGuid),
        data,
        token
      );
      if (response) {
        //Cleanup after the creating of a address
        handleClose();
        refetch();
        methods.reset();
        setLoading(false);
      }
    }
  });

  return (
    <>
      <IconButton
        iconClassName={''}
        onClick={handleShow}
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className="mx-2"
        iconalign="middle"
      >
        <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
          {t('new')}
        </span>
      </IconButton>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>{t('add_address_to_customer')}</Modal.Title>
          <FalconCloseButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-3"
            className="mx-2"
            iconalign="middle"
            noOutline={false}
            onClick={handleClose}
          />
        </Modal.Header>
        <FormProvider {...methods}>
          <Form onSubmit={() => CreateAddress()}>
            <Modal.Body>
              <Row>
                <Col lg={6}>
                  <Input {...street_validation} withLabel />
                </Col>

                <Col lg={6}>
                  <Input {...PLZ_validation} withLabel />
                </Col>
                <Col lg={6}>
                  <Input {...city_validation} withLabel />
                </Col>
                <Col lg={6}>
                  <Input {...country_validation} withLabel />
                </Col>
                <Col lg={6}>
                  <Input {...state_validation} withLabel />
                </Col>
              </Row>
              <div className="text-end">
                <Button
                  // onClick={UpdateTheCustomer}
                  variant="primary"
                  type="submit"
                >
                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                    t('create', { ns: 'labels' })
                  )}
                </Button>
              </div>
            </Modal.Body>
          </Form>
        </FormProvider>
      </Modal>
    </>
  );
}
